import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { Box } from '@mui/material';
import { useStore, } from '@mcn-platform/models';
import ModuleView from './ModuleView';
import getData from './getData';
import PlaceHolder from '../common/PlaceHolder';
import WysiwygTitle from './WysiwygTitle';
/**
 * Shows list of items in either a grid card view or a listing view.
 */
const ItemList = ({ categoryId, hubCategoryId, context, content, editData, configId, limitToPageWidth, settings: { showTitle, showToggleViewBtns, ItemCount, }, registerAction, disabled = false, }) => {
    // console.log('viewAction: ', viewAction);
    const store = useStore();
    const category = hubCategoryId
        ? store.currentHub.getCategory(hubCategoryId)
        : context.portal.getCategory(categoryId);
    const isEmpty = () => ((!categoryId || !category)
        && !(category && category.items && category.items.length)
        && content !== '' && editData)
        && !content.slate;
    if (isEmpty() && editData && editData.activeConfigId !== configId) {
        return (_jsx(PlaceHolder, { placeHolderName: "Configure Listing Grid" }));
    }
    return (_jsxs(Box, { sx: {
            my: 2,
            ...(limitToPageWidth && {
                maxWidth: 1200,
                marginX: 'auto',
                width: '100%',
            }),
        }, children: [(showTitle || showToggleViewBtns) && (_jsx(Box, { sx: {
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                }, children: _jsx(WysiwygTitle, { showTitle: showTitle, editData: editData, content: content, configId: configId, disabled: disabled }) })), category?.items?.length === 0 && editData && (_jsx(PlaceHolder, { placeHolderName: "Item List" })), category?.items?.length > 0 && (_jsx(ModuleView, { items: category.items, registerAction: registerAction, maxItems: ItemCount }))] }));
};
ItemList.defaultProps = {
    content: {
        slate: undefined,
        html: '<div>Title</div>',
    },
    settings: {
        showTitle: true,
        showToggleViewBtns: true,
        defaultItemView: 'tile',
    },
    registerAction: undefined,
    disabled: false,
};
/**
 * Initiates load of all dependent data.  Returns promise that will
 * resolve once loaded.
 * @param props same props used to render function
 */
ItemList.getData = getData;
ItemList.meta = {
    group: 'display',
    name: 'Item List',
    description: 'Display items (courses, programs, microcasts) in a grid or list',
    props: [
        {
            key: 'categoryId',
            name: 'Category',
            type: 'category',
            description: 'Category or group to display items from',
        },
        {
            key: 'viewAction',
            name: 'View Action',
            type: 'select',
            values: ['@viewItemAction', '@registerItemAction'],
            label: 'Main Action',
            labels: ['View Item', 'Register for Item'],
            description: 'Action to take when user selects an item.',
        },
        {
            key: 'settings.showTitle',
            name: 'Show Title',
            type: 'boolean',
            description: 'Show the title of items',
        },
        {
            key: 'content',
            name: 'Title',
            type: 'richtext', // note this is a special type recognized by the system
            description: 'Title of listing',
            inPlaceEdit: true,
        },
        {
            key: 'settings.ItemCount',
            name: 'Number of Items to Display',
            type: 'number',
            description: 'Limit the number if items in the list.',
        },
        {
            key: 'limitToPageWidth',
            name: 'Limit Width',
            type: 'boolean',
            description: 'Limit the width of the stack to the maximum page width',
            group: 'style',
        },
        {
            key: 'layout',
            name: 'Layout',
            type: 'layout',
            description: 'Layout properties such as spacing and background color.',
            group: 'style',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'ItemList',
        props: {
            content: {
                slate: undefined,
                html: '<div>&nbsp;</div>',
            },
            categoryId: '@categoryId',
            hubCategoryId: '@hubCategoryId',
            viewAction: '@viewItemAction',
            limitToPageWidth: true,
            settings: {
                showTitle: true,
                showToggleViewBtns: true,
                defaultItemView: 'list',
                ItemCount: 40,
            },
        },
    },
};
ItemList.IpeWrapper = WysiwygTitle.IpeWrapper;
ItemList.ipeControls = WysiwygTitle.ipeControls;
export default observer(ItemList);
//# sourceMappingURL=ItemList.js.map